import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { rangeMax, rangeMin } from './static-props'
import { ariaLabel } from '../../utils/form-utilities'

export const EnginePowerMin = withFacetContext(
    FacetName.engine_power,
    withFilterContext(FilterName.min_engine_power, SearchFiltersDropdown, {
        ...rangeMin,
        ariaLabel: ariaLabel.enginePower.min,
    })
)
export const EnginePowerMax = withFacetContext(
    FacetName.engine_power,
    withFilterContext(FilterName.max_engine_power, SearchFiltersDropdown, {
        ...rangeMax,
        ariaLabel: ariaLabel.enginePower.max,
    })
)
